<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div
      style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden"
    >
      <userLeft />

      <div class="box5">
        <div class="box6">我的积分</div>
        <div class="box7"></div>
        <div style="overflow: hidden; margin-top: 2%">
          <a-row :gutter="16">
            <a-col class="gutter-row" :span="6">
              <div class="gutter-box box8">
                <div class="box9">当前可使用积分</div>
                <div class="box10">{{ pointMy.pointBalance }}</div>
              </div>
            </a-col>
            <a-col class="gutter-row" :span="6">
              <div class="gutter-box box8">
                <div class="box9">历史累计积分</div>
                <div class="box10" style="color: #ff4d2a">
                  {{ pointMy.pointCumulative }}
                </div>
              </div>
            </a-col>
            <a-col class="gutter-row" :span="6">
              <div class="gutter-box box8">
                <div class="box9">冻结积分</div>
                <div class="box10" style="color: #b2b2b2">
                  {{ pointMy.pointFreezing }}
                </div>
              </div>
            </a-col>
            <a-col class="gutter-row" :span="6">
              <div class="gutter-box box8">
                <div class="box9">购买产品可获得积分</div>
                <router-link to="/"
                  ><div class="box11">前往购买</div></router-link
                >
              </div>
            </a-col>
          </a-row>
        </div>
        <div class="box6" style="margin-top: 4%">积分记录</div>
        <div class="box12">
          <div class="box13" style="width:30%">积分来源</div>
          <div class="box13">积分</div>
          <div class="box13" style="width:22.5%">时间</div>
          <div class="box13" style="color: #666666; float: left; width: 25%">
            <!-- <span style="float: left;margin-left: 20px;">积分来源</span>
            <a-icon type="down" style="float: left; margin-top: 6%; margin-left: 4%;" /> -->

            <div style="position: relative; z-index: 999999999">
              <a-range-picker
                :format="dateFormat"
                @change="jifenshijian_Change"
              />
            </div>

            <!-- <a-select
              default-value="近一个月的积分"
              style="width: 120px; background: #f4f4f4; border: none"
              @change="jifenshijian_Change"
            >
              <a-select-option value="近一个月的积分">
                近一个月的积分
              </a-select-option>
            </a-select> -->
          </div>
        </div>

        <div>
          <div
            :key="index" v-for="(item,index) in data_list"
            class="box12"
            style="
              margin-top: 0;
              background: none;
              border-bottom: 1px solid #eeeeee;
            "
          >
            <div class="boxs" style="width:30%">{{ item.origin }}</div>
            <div class="box13">{{ item.point }}</div>
            <div class="box13" style="width:22.5%">{{ item.createdAt }}</div>
            <div class="box13" style="width:25%"></div>
          </div>

          <div v-if="data_list.length == 0">
            <div style="text-align: center; margin: 40px 0">记录为空~</div>
          </div>
        </div>

        <div style="margin: 40px auto; text-align: center">
          <a-pagination
            :total="totalPages * 10"
            @change="fanye"
            show-less-items
          />
        </div>

        <div style="overflow: hidden">
          <div class="box6" style="margin-top: 4%">积分说明</div>
          <div class="box7" style="height: 150px">
            <div class="txt10">当前可使用积分：{{ pointMy.pointBalance }}</div>
            <div class="txt10">历史累计积分：{{ pointMy.pointCumulative }}</div>
            <div class="txt10">冻结积分：{{ pointMy.pointFreezing }}</div>
          </div>
        </div>

        <div style="overflow: hidden">
          <div class="box6" style="margin-top: 4%">科隆商城积分规则</div>
          <div class="box7" style="height: 150px">
            <div class="txt10">{{pointRuleConfig.descriptions}}</div>
          </div>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import axios from "axios";
import userLeft from "../public/user_left";
import htmlHeader from "../public/head";
import foot from "../public/foot";
export default {
  name: "integral",
  components: {
    userLeft,
    htmlHeader,
    foot,
  },
  data() {
    return {
      current: 1,
      totalPages: 1, //总页数
      page: 0,
      data_list: [],
      pointMy: "",
      startTime: "",
      endTime: "",

      dateFormat: "YYYY/MM/DD",
      pointRuleConfig: "", //积分规则获取
    };
  },
  methods: {
    // 积分配置获取
    get_pointRuleConfig() {
      this.api.get_pointRuleConfig().then((res) => {
        this.pointRuleConfig = res.data;
      });
    },
    // 翻页
    fanye(e) {
      this.page = e - 1;
      this.get_list();
    },
    // 切换积分时间
    jifenshijian_Change(e) {
      if(e.length == 2){
        this.endTime = this.format(Date.parse(e[1]._d));
        this.startTime = this.format(Date.parse(e[0]._d));
        this.get_list();
      }else{
        this.endTime = '';
        this.startTime = '';
        this.get_list();
      }
    },
    // 我的积分列表
    get_list() {
      this.api
        .get_point_log({
          page: this.page,
          startTime: this.startTime,
          endTime: this.endTime,
        })
        .then((res) => {
          this.data_list = res.data.content;
          this.totalPages = res.data.totalPages;
        });
    },

    // 我的积分
    get_pointMy() {
      this.api.get_pointMy().then((res) => {
        this.pointMy = res.data;
      });
    },
    // 时间戳转日期
    format(e) {
      var time = new Date(e);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      return y + "-" + this.add(m) + "-" + this.add(d);
    },
    add(m) {
      return m < 10 ? "0" + m : m;
    },
  },
  created() {
    this.get_list();
    this.get_pointMy();
    this.get_pointRuleConfig()
  },
};
</script>

<style scoped>
.ant-select-selection {
  background: none !important;
}

.txt10 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-top: 20px;
}

.ant-select-selection {
  background: none !important;
  border: none !important;
}
.boxs{
  width: 15%;
  height: 100%;
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.box13 {
  width: 15%;
  height: 100%;
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.box12 {
  width: 100%;
  height: 40px;
  background: #f4f4f4;
  margin-top: 4%;
}

.box11 {
  width: 100px;
  height: 32px;
  border: 1px solid #2b9a34;
  margin: 8% auto;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2b9a34;
}

.box10 {
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff9629;
  /* line-height: 16px; */
  margin: 4% auto;
}

.box9 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin: auto;
}

.box8 {
  width: 100%;
  height: 105px;
  background: #eef7ef;
  /* opacity: 0.08; */
  padding-top: 4%;
  text-align: center;
}

.box7 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #e8e6e6;
  margin-top: 2%;
}

.box6 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  /* margin-top: 2%; */
  text-align: left;
}

.box5 {
  min-height: 1023px;
  width: 80%;
  /* min-height: 1023px; */
  border: 1px solid #ede9e9;
  float: right;
  margin-top: 2%;
  padding: 2%;
}

.box3 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: Regular;
  color: #666666;
  margin-top: 6%;
}

.box4 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}

.box1 {
  width: 220px;
  min-height: 1023px;
  border: 1px solid #ede9e9;
  float: left;
  margin-top: 2%;
}

.box2 {
  width: 100%;
  height: 45px;
  background: #f2f2f2;
}

.ant-calendar-picker-container {
  position: relative;
  z-index: 999999999;
}
</style>



// WEBPACK FOOTER //
// src/components/integral.vue